import requestAuthSessionParams from 'src/dataLayer/remoteData/babbelAPI/requestAuthSessionParams'
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext'
import useAsyncData from 'src/viewLayer/components/hooks/useAsyncData'

export default function useHandleSessionRequest(email) {
  const { locale } = useRouteParamsContext()

  const { data, inProgress, makeRequest } = useAsyncData(() =>
    requestAuthSessionParams({ email, locale }),
  )

  return {
    authSessionRequestInProgress: inProgress,
    captchaConfig: data ? data.captchaConfig : null,
    makeAuthSessionRequest: makeRequest,
    sessionCode: data ? data.sessionCode : null,
  }
}
